// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"448":"8deb85f5","548":"8deb85f5","607":"8deb85f5","948":"8deb85f5"}[chunkId] + ".chunk.css";
};